import styled from '@emotion/styled';

export const SecUser = styled.section`
  display: flex;
  gap: 50px;
`;
export const Title = styled.p`
  font-size: 30px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0;
`;

export const Span = styled.span`
  font-size: 30px;
  color: white;
  text-shadow: #fc0 1px 0 10px;
`;
